import {
	configurationBase,
	sourceFileTypes,
	apiAuthenticationTypes,
	fileSelectorTypes,
	fileSortTypes
} from "@/models/importModels";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class importConfigurationBase extends Vue {
	@Prop({ default: () => new configurationBase() })
	value: configurationBase;
	get item(): configurationBase {
		return this.value;
	}
	set item(value: configurationBase) {
		this.$emit("input", value);
	}
	@Prop({ default: false })
	realTime: boolean;
	get isRealTime(): boolean {
		return this.realTime;
	}
	set isRealTime(v: boolean) {
		this.$emit("realTimeChange", v);
	}
	// onRealTimeChange(v: boolean) {
	// 	debugger;
	// 	this.$emit("realTimeChange", v);
	// }
	get labelFileNames(){
		var self = this;
		if(self.item != null){
			if (self.item.fileSelector == fileSelectorTypes.ONE_FILE) return "Nome del file <small class='text-muted'>(comprensivo di estenzione)</small>";
			if (self.item.fileSelector == fileSelectorTypes.MULTIPLE_FILES) return "Lista dei files <small class='text-muted'>(comprensivi di estenzione e separati da ';')</small>";
			if (self.item.fileSelector == fileSelectorTypes.NAME_CONTAINS) return "Sequenza di caratteri che deve contenere il nome del file";
			if (self.item.fileSelector == fileSelectorTypes.NAME_START) return "Sequenza di caratteri con cui inizia il nome del file";
			if (self.item.fileSelector == fileSelectorTypes.ALL_FILES) return "";
		}
		return "Nome del file";
	}
	get labelMultiFiles(){
		var self = this;
		// if(self.item != null){
		// 	if (self.item.fileSelector == fileSelectorTypes.ONE_FILE) return "Nome del file <small class='text-muted'>(comprensivo di estenzione)</small>";
		// 	if (self.item.fileSelector == fileSelectorTypes.MULTIPLE_FILES) return "Lista dei files <small class='text-muted'>(comprensivi di estenzione, separati da ';')</small>";
		// 	if (self.item.fileSelector == fileSelectorTypes.NAME_CONTAINS) return "Sequenza di caratteri che deve contenere il nome del file";
		// 	if (self.item.fileSelector == fileSelectorTypes.ALL_FILES) return "";
		// }
		return "Elabora tutti i file <small class='text-muted'>(se non selezionato elabora solo il primo file della lista)</small>";
	}
	get sourceTypesList() {
		var self = this;
		return Object.keys(sourceFileTypes).map(t => {
			return { value: t, text: self.$options.filters.sourceFileTypes(t) };
		});
	}
	get apiAuthenticationTypes() {
		var self = this;
		return Object.keys(apiAuthenticationTypes).map(t => {
			return { value: t, text: self.$options.filters.apiAuthenticationTypes(t) };
		});
	}
	
	get fileSelectorTypes() {
		var self = this;
		return Object.keys(fileSelectorTypes).map(t => {
			return { value: t, text: self.$options.filters.fileSelectorTypes(t) };
		});
	}
	
	get fileSortTypes() {
		var self = this;
		return Object.keys(fileSortTypes).map(t => {
			return { value: t, text: self.$options.filters.fileSortTypes(t) };
		});
	}
}
